module.exports = __webpack_public_path__ + "static/media/Hilma-logo-transparent.6ae3cfe3.png";